import { useState, useRef, useEffect } from "react";
// ** Reactstrap Imports
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { BiLeftArrowAlt } from "react-icons/bi";
import axios from "axios";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { MdOutlineAdd, MdRemove } from "react-icons/md";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import "react-quill/dist/quill.snow.css";
import useAuth from "../../hooks/useAuth";
import Select from "react-select";

const EditHomePageService = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();

  const [isEditMode, setIsEditMode] = useState(false);

  const [serviceInfo, setServiceInfo] = useState({});
  const fileInputRef = useRef();
  const [serviceImg, setServiceImg] = useState(null);
  const [mykey, setMyKey] = useState("");

  const ondescription = (value) => {
    setServiceInfo((prev) => {
      return {
        ...prev,
        serviceDesc: value,
      };
    });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image");
      } else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result);
        };
      }
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const addImage = async (e) => {
    setIsEditMode(true);

    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setServiceImg(e.target.files[0]);
  };

  const getData = async () => {
    try {
      await axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/homepage-services/find-service/${id}`,
          {
            headers: {
              Authorization: "Bearer " + auth.accessToken,
            },
          }
        )
        .then((res) => {
          setServiceInfo(res.data);
          setServiceImg(res.data && res.data.serviceImg);
        });
    } catch (error) {
      console.log(error);
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  // ** States
  //  let initialState = serviceInfo;

  const handleChange = (event) => {
    const { value, name } = event.target;
    setServiceInfo((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });
  };

  const handleUpdateClick = async (event) => {
    event.preventDefault();

    let serviceDesc = serviceInfo.serviceDesc;
    let serviceName = serviceInfo.serviceName;


    const formData = new FormData();
    formData.append("serviceName", serviceName);
    formData.append("serviceDesc", serviceDesc);
    formData.append("serviceImg", serviceImg);

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/homepage-services/update-service/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + auth.accessToken,
          },
        }
      );
      toast.success(res.data.message, {
        className: "success-toast",
        autoClose: 3000,
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      navigate("/homepage-services/view");
    } catch (error) {
      error.response.data.message
        ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          })
        : toast.error(error.response.data.error, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          });
    }
  };

  const handleReset = async (event) => {
    event.preventDefault();
    navigate("/homepage-services/view");
  };

  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Update Service</h5>
      </Row>
      <Row sm="12">
        <Card>
          <CardBody>
            <Col sm="12" className="mb-2">
              <Form>
                

                <div className="mb-1">
                  <Label className="form-label" for="serviceName">
                    Service Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="serviceName"
                    type="text"
                    className="me-1"
                    name="serviceName"
                    minLength={20}
                    maxLength={100}
                    placeholder="Suggested maximum characters limit 100"
                    required={true}
                    value={serviceInfo.serviceName}
                    onChange={handleChange}
                  />
                </div>

                <div className="mb-1">
                  <Label className="form-label" for="serviceDesc">
                    Service Description <span className="text-danger">*</span>
                  </Label>
                  <Input
                    id="serviceDesc"
                    type="textarea"
                    className="me-1"
                    name="serviceDesc"
                    placeholder="Suggested maximum characters limit 255"
                    minLength={20}
                    maxLength={255}
                    required={true}
                    value={serviceInfo.serviceDesc}
                    onChange={handleChange}
                  />
                </div>

              
                <div className="mb-1">
                  <Label className="form-label" for="serviceImg">
                    Image <span className="text-danger">(max size: 100KB, width: 650 x height 433)</span>
                  </Label>
                  <Input
                    id="serviceImg"
                    type="file"
                    className="me-1"
                    name="serviceImg"
                    accept="image/png, image/jpeg, image/jpg"
                    required={true}
                    key={mykey || ""}
                    ref={fileInputRef}
                    onChange={addImage}
                  />
                </div>
                {isEditMode ? (
                  <div className="mb-3 mt-3">
                    <div>
                      <img
                        style={{ width: 180 }}
                        src={
                          (fileInputRef &&
                            fileInputRef.current &&
                            fileInputRef.current.value) ||
                          ""
                        }
                      />
                    </div>
                  </div>
                ) : (
                  <div className="mb-3 mt-3">
                    <div>
                      {serviceImg && (
                        <img
                          style={{ width: 250 }}
                          src={`${
                            process.env.REACT_APP_API_IMAGE_URI.substring(
                              0,
                              process.env.REACT_APP_API_IMAGE_URI.indexOf(
                                "/api"
                              )
                            ) +
                            serviceImg.substring(serviceImg.indexOf("/uploads"))
                          }`}
                          alt="services-img"
                        ></img>
                      )}
                    </div>
                  </div>
                )}

                <Row className="pt-2">
                  <Col>
                    <div className="mb-1">
                      <Button
                        block
                        color="success"
                        type="submit"
                        onClick={handleUpdateClick}
                      >
                        Update
                      </Button>
                    </div>
                  </Col>
                  <Col>
                    <div className="mb-1">
                      <Button block color="warning" onClick={handleReset}>
                        Reset
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </CardBody>
        </Card>
      </Row>

      <Row sm="12" className="mt-4 text-center">
        <Link to={"/homepage-services/view"} className="go_back">
          <BiLeftArrowAlt size={30} /> Go to home page service list
        </Link>
      </Row>
    </div>
  );
};

export default EditHomePageService;
